import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex h-screen items-center justify-center"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div><div class=\"flex flex-col items-center space-y-2\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-28 w-28 text-[#2B8BD1]\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"1\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg><h1 class=\"text-4xl font-bold\">Thank You !</h1><p>Thank you for your interest! Check your email for a link to the guide.</p><a class=\"inline-flex items-center rounded border border-[#2B8BD1] bg-[#2B8BD1] px-4 py-2 text-white hover:bg-[#2B8BD1] focus:outline-none focus:ring\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"mr-2 h-3 w-3\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 16l-4-4m0 0l4-4m-4 4h18\"></path></svg><span class=\"text-sm font-medium\"> Login </span></a></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "min-h-screen bg-gray-100 text-gray-800 antialiased px-4 py-6 flex flex-col justify-center sm:py-12"
}
const _hoisted_5 = { class: "relative py-3 sm:max-w-xl w-2/5 mx-auto text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-bold" }, "Registre your account", -1)
const _hoisted_7 = { class: "relative mt-4 bg-white shadow-md sm:rounded-lg text-left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "h-2 bg-[#2B8BD1] rounded-t-md" }, null, -1)
const _hoisted_9 = { class: "py-6 px-8" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "block font-semibold" }, "FirstName", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "block font-semibold" }, "LastName", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "block font-semibold" }, "Username", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "block font-semibold" }, "Email", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-3 font-semibold" }, "Password", -1)

import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import UserService from '../services/userService'


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistreView',
  setup(__props) {

const router = useRouter();
const showPageThanks = ref(false)
const registersInfo  = ref({
    firstName:ref(''),
    lastName:ref(''),
    username:ref(''),
    password:ref(''),
    email:ref(''),
})
const saveInfo = () => {
    console.log(registersInfo.value)
    UserService.addRegistre(registersInfo.value)
    .then(( response: any ) => {
       console.log(response)
       showPageThanks.value = true
    })
    .catch((error:any) => {
     console.log(error)
    
   });
}; 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showPageThanks.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (!showPageThanks.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((registersInfo.value.firstName) = $event)),
                    placeholder: "firstName",
                    class: "border w-full h-5 px-3 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-[#2B8BD1] rounded-md"
                  }, null, 512), [
                    [_vModelText, registersInfo.value.firstName]
                  ]),
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((registersInfo.value.lastName) = $event)),
                    placeholder: "LastName",
                    class: "border w-full h-5 px-3 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-[#2B8BD1] rounded-md"
                  }, null, 512), [
                    [_vModelText, registersInfo.value.lastName]
                  ]),
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((registersInfo.value.username) = $event)),
                    placeholder: "Username",
                    class: "border w-full h-5 px-3 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-[#2B8BD1] rounded-md"
                  }, null, 512), [
                    [_vModelText, registersInfo.value.username]
                  ]),
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((registersInfo.value.email) = $event)),
                    placeholder: "Email",
                    class: "border w-full h-5 px-3 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-[#2B8BD1] rounded-md"
                  }, null, 512), [
                    [_vModelText, registersInfo.value.email]
                  ]),
                  _hoisted_14,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((registersInfo.value.password) = $event)),
                    placeholder: "Password",
                    class: "border w-full h-5 px-3 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-[#2B8BD1] rounded-md"
                  }, null, 512), [
                    [_vModelText, registersInfo.value.password]
                  ]),
                  _createElementVNode("div", { class: "flex justify-between items-baseline" }, [
                    _createElementVNode("button", {
                      onClick: saveInfo,
                      class: "mt-4 bg-[#2B8BD1] text-white py-2 px-6 rounded-lg hover:bg-[#2B8BD1]"
                    }, "Registre")
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})